export const disconnectionSchema = {
  title: 'Disconnection',
  type: 'object',
  properties: {
    mpan_core: {
      type: 'string',
      title: 'MPAN Core',
    },
    disconnection_type: {
      type: 'string',
      title: 'Disconnection Type',
      enum: ['A', 'P', 'U'],
      enumNames: ['A – Actual', 'P – Planned', 'U – Unplanned'],
    },
    additional_information: {
      type: 'string',
      title: 'Additional Information',
    },
    appointment_date: {
      type: 'string',
      title: 'Appointment Date',
      pattern: '^\\d{8}$',
    },
    earliest_appointment_time: {
      type: 'string',
      title: 'Earliest Appointment Time',
      pattern: '^\\d{6}$',
    },
    latest_appointment_time: {
      type: 'string',
      title: 'Latest Appointment Time',
      pattern: '^\\d{6}$',
    },
  },
  required: ['mpan_core', 'disconnection_type'],
};

export const disconnectionUISchema = {
  mpan_core: {
    'ui:placeholder': 'Select MPAN',
  },
  disconnection_type: {
    'ui:widget': 'select',
    'ui:placeholder': 'Select Disconnection Type',
  },
  additional_information: {
    'ui:widget': 'textarea',
    'ui:placeholder': 'Enter additional information (optional)',
  },
  appointment_date: {
    'ui:placeholder': 'yyyyMMdd (e.g. 20250612)',
  },
  earliest_appointment_time: {
    'ui:placeholder': 'HHmmss (e.g. 120000)',
  },
  latest_appointment_time: {
    'ui:placeholder': 'HHmmss (e.g. 160000)',
  },
};
